module.exports = __webpack_public_path__ + "static/media/05-IndividualBCS.794c710b.gif";